import React from 'react'
import image from '../../../assets/homepage_pro3.png'
const BannerBoxThree = () => {
    return (
        <>
            <div className="box1 bg-yellow">
                <div className="bx-txt">
                    <h4>Watches</h4>
                    <h3>
                        Extra <span>30% Off</span> All Sale Styles
                    </h3>
                    <a href="#" className="btn-buy">
                        BUY NOW
                    </a>
                </div>
                <div className="bx-img">
                    <img className="img-fluid" src={image} alt="" />
                </div>
            </div>

        </>
    )
}

export default BannerBoxThree